export const workspaceCountView = (workspaceCount, containsX) => {
  let result = "";
  if (workspaceCount === 0) {
    return containsX?"x":"0";
  }
  if (workspaceCount) result += workspaceCount;
  if (containsX && workspaceCount) result += " + ";
  if (containsX) result += "x";
  return result;
};
